import React from 'react';

export function getTextFromReactNode(node: React.ReactNode): string {
  if (node == null) return '';

  if (typeof node === 'string' || typeof node === 'number') return String(node);

  if (Array.isArray(node)) {
    return node.map(getTextFromReactNode).filter(Boolean).join(' ');
  }

  if (React.isValidElement(node)) {
    if (node.props?.accessibilityLabel) {
      return node.props.accessibilityLabel;
    }

    return getTextFromReactNode(node.props.children);
  }

  if (
    typeof node === 'object' &&
    node !== null &&
    'total' in node &&
    (typeof node.total === 'number' || typeof node.total === 'string')
  ) {
    return String(node.total);
  }

  // Otherwise skip unknown objects
  return '';
}
